import { memo, useMemo } from 'react';

import type { RelevancyCardProps } from '../DynamicCardComponent';
import { useRelevancyOptions } from '../store';
import type { RelevancyFeedOptions } from '../types';

import { trackCardElement } from '@services/GoogleTagManagerService';
import FormGuide from '@shared/match-summary/FormGuide';
import type { Match } from '@shared-types/match.types';
import { competitionId } from '@utilities/WindowContext';

const FormGuideComponent = ({ item }: RelevancyCardProps) => {
  const { options } = useRelevancyOptions();
  const cardOptions: RelevancyFeedOptions & { match: Match; extendedView: boolean } = useMemo(
    () => ({
      ...options,
      match: {
        ...item.teaser,
        competition: { id: competitionId },
        id: item.teaser.matchId,
      },
      extendedView: true,
    }),
    [item.teaser, options],
  );

  const sponsorName = useMemo(
    () => !options.disableSponsors && (item.teaser.sponsor?.type ?? item.teaser.sponsors?.at(0)),
    [options.disableSponsors, item],
  );

  const trackingData = useMemo(
    () => ({
      category: 'form guide',
      name: [
        sponsorName,
        `Form guide - ${cardOptions.match?.homeTeam?.internationalName}-${cardOptions.match?.awayTeam?.internationalName}`,
      ]
        .filter(Boolean)
        .join(' - '),
    }),
    [cardOptions.match?.awayTeam?.internationalName, cardOptions.match?.homeTeam?.internationalName, sponsorName],
  );

  return (
    <div ref={trackCardElement(trackingData)} pk-theme='light' className='card form-guide-component'>
      <FormGuide options={cardOptions} />
    </div>
  );
};

export default memo(FormGuideComponent);
